import React, { useState } from 'react'
import HoaChoosePlan from '../HoaChoosePlan/HoaChoosePlan';

const HoaModal = () => {
    const [modal, setModal] = useState(false);

    const toggleModal = () => {
        setModal(!modal)
    }

    if (modal) {
        document.body.classList.add('active-modal')
    }
    else {
        document.body.classList.remove('active-modal')
    }

    return (
        <div>
            <button
                onClick={toggleModal}
                className='bg-blue-800 text-white px-6 py-3 rounded-md font-semibold hover:bg-blue-700 transition-colors duration-300 cursor-pointer border-none'
            >
                Open
            </button>

            {modal && (
                <div className="fixed inset-0 z-[9999] bg-black bg-opacity-50 flex items-center justify-center">
                    <div
                        onClick={toggleModal}
                        className="absolute inset-0"
                    ></div>
                    <div className="relative bg-white rounded-lg shadow-2xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
                        <div className="relative">
                            <HoaChoosePlan closeModal={toggleModal} />
                            <button
                                className='absolute top-4 right-4 bg-red-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-red-600 transition-colors duration-300 cursor-pointer border-none z-10'
                                onClick={toggleModal}
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default HoaModal